export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_14.f064840f.jpg";